const Keys = {
  fake: 'fake',
  wxgzhOpenid: 'openid',
  wxgzhPassport: 'passport',
  wxgzhCropid: 'corpId',
  wxgzhQwUserId: 'qwUserId',
  userRole: 'userRole',
}
// 测试环境
const devConfig = {
  apiBaseURL: "https://tmarketingapi.newhope.cn",
  CorpId: "wpO3ZZCAAA-AJ8BPszNSZMfOlD_M36WA",
  AppId: "1000088",
  xiWangYunAppletId: "wx2820b54fabb451f4",
  marketingUrl: 'https://tmarketingapi.newhope.cn/marketies/qwdesk'
}
// 正式环境
const proConfig = {
  apiBaseURL: "https://marketingapi.newhope.cn",
  CorpId: "ww6b916badbf80428f",
  AppId: "1000083",
  xiWangYunAppletId: "wxd783c47e55dce1de",
  marketingUrl: 'https://marketing.newhope.cn/marketies/qwdesk' // 正式环境
}

console.log('----------storage.ts-----window.location.host----', window.location.host);
let BaseConfig = import.meta.env.DEV ? devConfig : proConfig;
if (window.location.host.indexOf('repaytest') > -1) {
  BaseConfig = devConfig;
}

export {
  Keys,
  BaseConfig
}